export default class Modal {
    constructor() {
        this.createModal();
        this.bindEvents();
    }

    createModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'stc-modal';

        //<button data-side="back">Back</button>

        this.modal.innerHTML = `
            <div class="stc-modal-header">
                <button class="stc-modal-close">
                    <span>×</span> Close
                </button>
                <h2 class="stc-modal-title">Design Your Card</h2>
                <div class="stc-side-switch">
                    <button class="is-active" data-side="front">Front</button>
                </div>
            </div>
            <div class="stc-modal-container">
                <div class="stc-steps">
                    <div class="stc-steps-list"></div>
                    <div class="stc-steps-footer">
                        <div class="stc-price-summary">
                            <div class="stc-price-row">
                                <span>Base Price</span>
                                <span>$29.99</span>
                            </div>
                            <div class="stc-price-row">
                                <span>Extra Features</span>
                                <span>+$14.97</span>
                            </div>
                            <div class="stc-price-row stc-price-total">
                                <span>Total Price</span>
                                <span>$44.96</span>
                            </div>
                        </div>
                        <button class="stc-add-to-cart">Add to Cart</button>
                    </div>
                </div>
                <div class="stc-canvas-container">
                    <!-- Canvas will be mounted here -->
                </div>
            </div>
        `;

        document.body.appendChild(this.modal);
    }

    bindEvents() {
        // Close button
        this.modal.querySelector('.stc-modal-close').addEventListener('click', () => {
            this.hide();
        });

        // Side switch
        const sideButtons = this.modal.querySelectorAll('.stc-side-switch button');
        sideButtons.forEach(button => {
            button.addEventListener('click', () => {
                let buttonWasActive = button.classList.contains('is-active');
                sideButtons.forEach(btn => btn.classList.remove('is-active'));
                if(!buttonWasActive) button.classList.add('is-active');
                this.emit('sideChange', button.dataset.side);
            });
        });

        // Escape key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isVisible()) {
                this.hide();
            }
        });
    }

    show() {
        document.body.style.overflow = 'hidden';
        this.modal.classList.add('is-active');
        this.emit('show');
    }

    hide() {
        // Emit cancellable beforeHide event BEFORE closing
        const beforeHideEvent = new CustomEvent('stc:modal:beforeHide', { cancelable: true });
        this.modal.dispatchEvent(beforeHideEvent);
        if (beforeHideEvent.defaultPrevented) return;

        document.body.style.overflow = '';
        this.modal.classList.remove('is-active');
        this.emit('hide');
    }

    isVisible() {
        return this.modal.classList.contains('is-active');
    }

    emit(eventName, detail = {}) {
        const event = new CustomEvent(`stc:modal:${eventName}`, { detail });
        this.modal.dispatchEvent(event);
    }

    on(eventName, callback) {
        this.modal.addEventListener(`stc:modal:${eventName}`, callback);
    }

    off(eventName, callback) {
        this.modal.removeEventListener(`stc:modal:${eventName}`, callback);
    }
}